import { render, staticRenderFns } from "./LongButton.vue?vue&type=template&id=b81bd144&"
import script from "./LongButton.vue?vue&type=script&lang=ts&"
export * from "./LongButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports